// Central site content — edit here to update copy across the site.

export const site = {
  brand: {
    name: "Ashrita Overseas",
    short: "Ashrita",
    tagline: "Sourcing Sustainable Packaging Solutions from India",
    mission: "Protecting the Earth through sustainable solutions.",
    logo: "https://customer-assets.emergentagent.com/job_sustainable-pack-8/artifacts/gsuh5icr_ChatGPT%20Image%20Jul%204%2C%202026%2C%2008_30_26%20PM.png",
  },
  contact: {
    email: "sales@ashrita.co.in",
    phone: "+91 91670 00705",
    whatsapp: "919167000705", // international format, no + or spaces
    address: "Casa Rio Palava City, Dombivali East, Thane 421204, Maharashtra, India",
    hours: "Monday to Sunday · 365 Days",
    map: "https://maps.google.com/maps?q=Casa%20Rio%20Palava%20City%2C%20Dombivali%20East%2C%20Thane%20421204%2C%20Maharashtra%2C%20India&t=m&z=15&ie=UTF8&iwloc=&output=embed",
  },
  social: {
    linkedin: "https://www.linkedin.com/",
    instagram: "https://www.instagram.com/",
    facebook: "https://www.facebook.com/",
    youtube: "https://www.youtube.com/",
  },
  catalogue_pdf: "/catalogue.pdf", // placeholder — replace later
};

export const nav = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Industries", href: "#industries" },
  { label: "Export Process", href: "#process" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const trustBadges = [
  "Merchant Exporter",
  "Global Shipping",
  "Private Label Solutions",
  "Sustainable Packaging",
  "Reliable Manufacturing Partners",
];

export const aboutValues = [
  {
    icon: "ShieldCheck",
    title: "Quality",
    body: "Every shipment is inspected against agreed specifications before dispatch.",
  },
  {
    icon: "Handshake",
    title: "Trust",
    body: "A transparent, documentation-first process from enquiry to delivery.",
  },
  {
    icon: "Globe2",
    title: "Global Reach",
    body: "Multimodal shipping — sea, air, courier — to buyers across continents.",
  },
  {
    icon: "Leaf",
    title: "Sustainability",
    body: "We only work with recyclable, biodegradable and eco-friendly packaging.",
  },
];

export const whyChooseUs = [
  {
    icon: "Factory",
    title: "Trusted Manufacturing Partners",
    body: "A verified supplier network across India, vetted for capacity, compliance and consistency.",
  },
  {
    icon: "ClipboardCheck",
    title: "Quality Inspection",
    body: "Pre-shipment inspection on every export order — you approve before it ships.",
  },
  {
    icon: "Palette",
    title: "Custom Branding",
    body: "OEM and private-label with your artwork, colors, sizes and finish.",
  },
  {
    icon: "BadgeIndianRupee",
    title: "Competitive Pricing",
    body: "Direct export pricing without unnecessary intermediaries or hidden fees.",
  },
  {
    icon: "Ship",
    title: "Global Shipping",
    body: "Sea, air and multimodal freight support with end-to-end documentation.",
  },
  {
    icon: "Headset",
    title: "Dedicated Export Support",
    body: "Fast quotations, responsive communication and a single point of contact.",
  },
];

export const industries = [
  { icon: "Coffee", name: "Coffee Chains" },
  { icon: "UtensilsCrossed", name: "Restaurants" },
  { icon: "Hotel", name: "Hotels" },
  { icon: "Bike", name: "Food Delivery Brands" },
  { icon: "ShoppingCart", name: "Supermarkets" },
  { icon: "Package", name: "Packaging Distributors" },
  { icon: "Store", name: "Retail Chains" },
  { icon: "Gift", name: "Promotional Product Companies" },
  { icon: "BedDouble", name: "Hospitality Suppliers" },
];

export const markets = [
  { code: "US", name: "United States", flag: "🇺🇸", x: 22, y: 42 },
  { code: "CA", name: "Canada", flag: "🇨🇦", x: 24, y: 30 },
  { code: "UK", name: "United Kingdom", flag: "🇬🇧", x: 47, y: 34 },
  { code: "DE", name: "Germany", flag: "🇩🇪", x: 51, y: 37 },
  { code: "AE", name: "United Arab Emirates", flag: "🇦🇪", x: 62, y: 48 },
  { code: "AU", name: "Australia", flag: "🇦🇺", x: 84, y: 74 },
];

export const processSteps = [
  { icon: "Mail", title: "Send Your Enquiry", body: "Share products, quantities and destination — we respond within 24 hours." },
  { icon: "FileText", title: "Receive Quotation", body: "A detailed FOB / CIF quotation with specifications, lead time and Incoterms." },
  { icon: "PackageCheck", title: "Sample Approval", body: "Physical samples for artwork, material and color approval before production." },
  { icon: "Factory", title: "Production", body: "Manufacturing at partner facilities with in-line quality monitoring." },
  { icon: "ClipboardCheck", title: "Quality Inspection", body: "Pre-shipment inspection with photo/video reports for your sign-off." },
  { icon: "Ship", title: "Worldwide Shipping", body: "Sea / air / courier with full export documentation to your port." },
];

export const faqs = [
  {
    q: "What is your minimum order quantity?",
    a: "MOQ varies by product. Typically 20,000–50,000 units for paper cups, 5,000–10,000 units for paper bags, and 1,000–3,000 units for jute bags. Share your requirement and we will confirm the exact MOQ.",
  },
  {
    q: "Can you provide custom branding?",
    a: "Yes. Full OEM / private-label service — your artwork, Pantone colors, sizes and finishing. We share digital mock-ups and physical samples for approval before production.",
  },
  {
    q: "Which countries do you export to?",
    a: "We currently support buyers in the United States, Canada, United Kingdom, Germany, Australia and the UAE, and are open to new markets on request.",
  },
  {
    q: "Can you arrange shipping?",
    a: "Yes. We arrange FOB, CIF and door-to-door shipping via sea, air or multimodal freight, along with all export documentation.",
  },
  {
    q: "Do you provide samples?",
    a: "Yes. Reference samples are provided against a nominal cost + courier — the cost is adjusted against confirmed orders.",
  },
  {
    q: "What payment terms do you accept?",
    a: "Standard export terms — 30% advance TT with balance against BL copy, or 100% irrevocable L/C at sight. Alternative structures are considered for repeat buyers.",
  },
  {
    q: "How long is production?",
    a: "Typical lead time is 25–45 days from artwork approval, depending on product, quantity and season.",
  },
];

// Product catalogue
export const products = [
  {
    id: "paper-cups",
    name: "Paper Cups",
    tagline: "Single Wall, Ripple & Double Wall Cups",
    image:
      "https://customer-assets.emergentagent.com/job_sustainable-pack-8/artifacts/rmirls3b_ChatGPT%20Image%20Jul%204%2C%202026%2C%2010_47_47%20PM.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_sustainable-pack-8/artifacts/rmirls3b_ChatGPT%20Image%20Jul%204%2C%202026%2C%2010_47_47%20PM.png",
    ],
    types: [
      "Single Wall Plain/Printed Paper Cups",
      "Ripple Wall Paper Cups",
      "Double Wall Paper Cups",
    ],
    variants: [
      {
        name: "Single Wall Plain/Printed",
        image:
          "https://customer-assets.emergentagent.com/job_sustainable-pack-8/artifacts/b72tev0p_SINGLEWALLPAPERCUP.webp",
      },
      {
        name: "Ripple Wall",
        image:
          "https://customer-assets.emergentagent.com/job_sustainable-pack-8/artifacts/3c9xsj6y_RIPPLEWALLPAPERCUP.webp",
      },
      {
        name: "Double Wall",
        image:
          "https://customer-assets.emergentagent.com/job_sustainable-pack-8/artifacts/fkrrok6m_DOUBLEWALLPAPERCUP.webp",
      },
    ],
    specs: [
      { label: "Sizes", value: "4 oz – 24 oz" },
      { label: "GSM", value: "170 – 350 GSM" },
      { label: "Material", value: "Virgin food-grade paperboard, PE / PLA lining" },
    ],
  },
  {
    id: "paper-bags",
    name: "Paper Bags",
    tagline: "V Bottom · Square Bottom · Flat Handle Carry Bag · Twisted Handle Carry Bag",
    image:
      "https://customer-assets.emergentagent.com/job_sustainable-pack-8/artifacts/cfkubfth_ChatGPT%20Image%20Jul%204%2C%202026%2C%2010_43_24%20PM.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_sustainable-pack-8/artifacts/cfkubfth_ChatGPT%20Image%20Jul%204%2C%202026%2C%2010_43_24%20PM.png",
    ],
    types: [
      "V Bottom",
      "Square Bottom",
      "Flat Handle Carry Bag",
      "Twisted Handle Carry Bag",
    ],
    variants: [
      {
        name: "V Bottom",
        image:
          "https://customer-assets.emergentagent.com/job_sustainable-pack-8/artifacts/41i83uio_images%20%284%29.jpg",
      },
      {
        name: "Square Bottom",
        image:
          "https://customer-assets.emergentagent.com/job_sustainable-pack-8/artifacts/3ovejtqr_images%20%286%29.jpg",
      },
      {
        name: "Twisted Handle Carry Bag",
        image:
          "https://customer-assets.emergentagent.com/job_sustainable-pack-8/artifacts/oyz9h3lt_images%20%283%29.jpg",
      },
    ],
    specs: [
      { label: "Sizes", value: "Custom — small carry to large grocery" },
      { label: "Handles", value: "Twisted Paper, Flat Paper, Cotton Rope, Ribbon" },
    ],
  },
  {
    id: "compostable-packaging",
    name: "Compostable Packaging",
    tagline: "Compostable Garbage Bags on Roll · Compostable Courier Bag · Compostable Gloves",
    fit: "cover",
    image:
      "https://customer-assets.emergentagent.com/job_sustainable-pack-8/artifacts/ibmv4ack_ChatGPT%20Image%20Jul%204%2C%202026%2C%2010_49_33%20PM.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_sustainable-pack-8/artifacts/ibmv4ack_ChatGPT%20Image%20Jul%204%2C%202026%2C%2010_49_33%20PM.png",
    ],
    types: [
      "Compostable Garbage Bags on Roll",
      "Compostable Courier Bag",
      "Compostable Gloves",
    ],
    variants: [
      {
        name: "Compostable Garbage Bags on Roll",
        image:
          "https://customer-assets.emergentagent.com/job_sustainable-pack-8/artifacts/92cgj51d_images%20%281%29.jpg",
      },
      {
        name: "Compostable Courier Bag",
        image:
          "https://customer-assets.emergentagent.com/job_sustainable-pack-8/artifacts/ga2m85gh_2b6e2bd0-3a42-403d-9258-9c5ae9e562b8.png",
      },
      {
        name: "Compostable Gloves",
        image:
          "https://customer-assets.emergentagent.com/job_sustainable-pack-8/artifacts/22umsgdc_gloves-1024x1024.webp",
      },
    ],
    specs: [
      { label: "Sizes", value: "Custom — small courier mailers to XL bin liners" },
      { label: "Material", value: "PLA + PBAT + corn starch (home & industrial compostable)" },
    ],
  },
];

export const stats = [
  { value: 6, suffix: "+", label: "Export Markets" },
  { value: 25, suffix: "+", label: "Verified Partners" },
  { value: 50, suffix: "M+", label: "Units Shipped Annually" },
  { value: 98, suffix: "%", label: "On-Time Delivery" },
];
